import {
  TOGGLE_REVIEW_DATA_LOADING,
  UPDATE_TENTATIVE_ACTION,
  SET_GO_SAFE_SOCIAL_DATA,
  SET_GO_SAFE_DATA,
  SET_DEPOT_REVIEW_API,
  SET_SELECTED_PROMO_CODE,
  TOGGLE_GOCASH_SELECTION,
  UPDATE_GOTRIBE_DETAILS,
  UPDATE_GOTRIBE
} from './constants';
import { ITOGGLE_REVIEW_DATA_LOADING, IUPDATE_TENTATIVE_ACTION } from './Validation';

export function toggleReviewDataLoading(
  actionData: ITOGGLE_REVIEW_DATA_LOADING['actionData'],
): ITOGGLE_REVIEW_DATA_LOADING {
  return {
    type: TOGGLE_REVIEW_DATA_LOADING,
    actionData,
  };
}

export function updateTentativeAction(
  actionData: IUPDATE_TENTATIVE_ACTION['actionData'],
): IUPDATE_TENTATIVE_ACTION {
  return {
    type: UPDATE_TENTATIVE_ACTION,
    actionData,
  };
}

export function setGoSafeData(actionData: any) {
  return {
    type: SET_GO_SAFE_DATA,
    actionData
  }
}
export function setGoSafeSocialData(actionData: any) {
  return {
    type: SET_GO_SAFE_SOCIAL_DATA,
    actionData
  }
}
export function setDepotReviewAPI(actionData: any) {
  return {
    type: SET_DEPOT_REVIEW_API,
    actionData
  }
}
export function setSelectedPromoCode(actionData: any) {
  return {
    type: SET_SELECTED_PROMO_CODE,
    actionData
  }
}
export function toggleGoCashSelection(actionData: any) {
  return {
    type: TOGGLE_GOCASH_SELECTION,
    actionData
  }
}

export const setGoTribe = (actionData: {}, showTribeData: boolean) => {
  return {
    type: UPDATE_GOTRIBE_DETAILS,
    tribeDetails: {
      tribeData: actionData,
      showTribeData: showTribeData,
    }
  }
}

export const updateGoTribeData = (showTribeData: boolean) => {
  return {
    type: UPDATE_GOTRIBE,
    showTribeData: showTribeData,
  }
}
